import { MasterDataVehicleListPage } from "@/pages/master-data-vehicle-list";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/master-data/vehicles/")({
  component: () => <MasterDataVehicleListPage />,
});
